/* WheelsUp – kola s TÜV/KBA posudkem podle E čísla (číslo schválení typu z TP, pole K) nebo VIN.
   Data: vyhledávací index na Cloudflare Workeru (data-index):
     {index}/meta.json                      -> { verze }
     {index}/<verze>/e/<slug E čísla>.json  -> { es, d: [[i dokladu, řádky vozů, úprava podběhu 0/1], …] }
     {index}/<verze>/doklady.json           -> { doklady: [[číslo, typ, pdf, model, rozměr, varianty, kroužky, šrouby, moment, [i kol]], …] }
     {index}/<verze>/produkty.json          -> { produkty: [[handle, název, obrázek, cena od], …] }
   VIN: Worker registru (data-vin) musí vracet pole "es" (číslo schválení typu) a volitelně "kw". */
(function () {
  'use strict';
  var RE_VIN = /^[A-HJ-NPR-Z0-9]{17}$/;
  var RE_ES = /^e\d{1,2}\*(?:KS)?\d{2,4}\/\d{1,4}(?:\*\d{2,4}\/\d{1,4})?\*[0-9A-Z]{2,6}(?:\*[0-9.]{1,3})?$/i;

  function esBase(s) {
    s = String(s || '').trim().replace(/\s+/g, '').replace(/^E/, 'e');
    var p = s.split('*');
    if (p.length >= 4) p = p.slice(0, 3);   // bez rozšíření (*28, *..)
    return p.join('*');
  }
  function slug(es) { return es.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function isBlank(title) { return /BLANK|\s\dH\s/i.test(title); }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var t = root.dataset, base = (t.index || '').replace(/\/$/, ''), vinUrl = (t.vin || '').replace(/\/$/, '');
    var form = root.querySelector('form'), q = root.querySelector('[name="q"]'), kwIn = root.querySelector('[name="kw"]');
    var msg = root.querySelector('[data-msg]'), out = root.querySelector('[data-result]'), btn = form.querySelector('button');
    var cache = {}, ver = null;
    function get(path) {
      return cache[path] || (cache[path] = fetch(path).then(function (r) { if (!r.ok) throw r.status; return r.json(); }));
    }
    function meta() {
      return ver ? Promise.resolve(ver) : fetch(base + '/meta.json', { cache: 'no-cache' }).then(function (r) { return r.json(); })
        .then(function (m) { ver = m.verze; return ver; });
    }
    function say(text, err) { msg.textContent = text || ''; msg.hidden = !text; msg.classList.toggle('wu-tuv__msg--error', !!err); }

    function money(n) { return n == null ? '' : (t.tFrom || 'od') + ' ' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + (t.currency || 'Kč'); }

    function render(es, E, D, P, kw) {
      out.textContent = '';
      // kolo -> {p, doklady: [{d, rows, np}]}
      var byP = {}, order = [];
      E.d.forEach(function (x) {
        var d = D[x[0]], rows = x[1] || [], np = !!x[2];
        if (kw) rows = rows.filter(function (r) { return r[2] == null || (kw >= r[2] && kw <= (r[3] == null ? r[2] : r[3])); });
        if (kw && !rows.length && !np) return;
        (d[9] || []).forEach(function (pi) {
          if (!byP[pi]) { byP[pi] = { p: P[pi], docs: [] }; order.push(pi); }
          byP[pi].docs.push({ d: d, rows: rows, np: np });
        });
      });
      if (!order.length) { say(kw ? (t.tNoneKw || 'Pro tento výkon jsme kola s posudkem nenašli. Zkuste hledat bez kW.') : (t.tNone || 'K tomuto vozu zatím nemáme kola s posudkem.'), true); return; }
      say((t.tFound || 'Nalezeno kol s posudkem: #N#').replace('#N#', order.length) + ' · ' + es);
      var grid = el('div', 'wu-tuv__grid');
      order.forEach(function (pi) {
        var it = byP[pi], p = it.p, card = el('article', 'wu-tuv__card');
        var a = el('a', 'wu-tuv__link'); a.href = (t.root || '/') .replace(/\/$/, '') + '/products/' + p[0];
        if (p[2]) { var img = el('img', 'wu-tuv__img'); img.src = p[2] + '?width=400'; img.alt = p[1]; img.loading = 'lazy'; img.width = 400; img.height = 400; a.appendChild(img); }
        a.appendChild(el('h3', 'wu-tuv__title', p[1]));
        if (p[3] != null) a.appendChild(el('p', 'wu-tuv__price', money(p[3])));
        card.appendChild(a);
        var blank = isBlank(p[1]), np = it.docs.some(function (x) { return x.np; });
        if (np) card.appendChild(el('p', 'wu-tuv__flag', t.tNp || 'Vyžaduje úpravu podběhu / blatníku (viz posudek)'));
        var det = el('details', 'wu-tuv__det'); det.appendChild(el('summary', null, (t.tDocs || 'Posudky a podmínky') + ' (' + it.docs.length + ')'));
        it.docs.forEach(function (x) {
          var d = x.d, box = el('div', 'wu-tuv__doc');
          var h = el('p', 'wu-tuv__doc-h'); h.appendChild(el('strong', null, (d[1] || '') + ' ' + (d[0] || '')));
          if (d[2]) { h.appendChild(document.createTextNode(' · ')); var l = el('a', null, t.tPdf || 'PDF posudku'); l.href = d[2]; l.target = '_blank'; l.rel = 'noopener'; h.appendChild(l); }
          box.appendChild(h);
          if (blank && d[5] && d[5].length) {
            box.appendChild(el('p', 'wu-tuv__var', (t.tVar || 'Platí pro provedení') + ': ' + d[5].map(function (v) { return v[0] + ' ET' + v[1] + (v[2] ? ' CB ' + String(v[2]).replace('.', ',') : ''); }).join(' · ')));
            if (d[6] && d[6].length) box.appendChild(el('p', 'wu-tuv__var', (t.tRings || 'Kroužky') + ': ' + d[6].map(function (r) { return String(r[0]).replace('.', ',') + '→' + String(r[1]).replace('.', ','); }).join(', ')));
          }
          x.rows.slice(0, 12).forEach(function (r) {
            var line = [r[1], r[0], r[2] ? r[2] + (r[3] && r[3] !== r[2] ? '–' + r[3] : '') + ' kW' : null].filter(Boolean).join(' · ');
            var rr = el('div', 'wu-tuv__row'); rr.appendChild(el('p', 'wu-tuv__veh', line));
            if (r[4] && r[4].length) rr.appendChild(el('p', 'wu-tuv__tyre', (t.tTyres || 'Pneu') + ': ' + r[4].join(', ')));
            var cond = (r[5] || '').replace(/(^|[\s;])(?:\d{2}[A-Z]|\d{3}|[A-Z]{3}|\d[A-Z]{2})(?=[\s;]|$)/g, '$1').replace(/\s*;\s*(;\s*)+/g, '; ').replace(/^[\s;]+|[\s;]+$/g, '');
            if (cond) rr.appendChild(el('p', 'wu-tuv__cond', cond));
            box.appendChild(rr);
          });
          // šrouby a utahovací moment se v posudku liší podle značky vozu -> odkaz na PDF místo jedné (možná zavádějící) hodnoty
          if (d[7] && d[7].length) box.appendChild(el('p', 'wu-tuv__small', t.tBolts || 'Šrouby, kroužky a utahovací moment podle posudku (PDF).'));
          det.appendChild(box);
        });
        card.appendChild(det);
        grid.appendChild(card);
      });
      out.appendChild(grid); out.hidden = false;
    }

    function searchEs(es, kw) {
      es = esBase(es);
      if (!RE_ES.test(es)) { say(t.tInvalid || 'Zadejte VIN (17 znaků) nebo číslo schválení typu, např. e1*2007/46*1885.', true); return Promise.resolve(); }
      say(t.tLoading || 'Hledám…');
      return meta().then(function (v) {
        var b = base + '/' + v;
        return Promise.all([get(b + '/e/' + slug(es) + '.json').catch(function (s) { if (s === 404) return null; throw s; }),
                            get(b + '/doklady.json'), get(b + '/produkty.json')]);
      }).then(function (r) {
        if (!r[0]) { say(t.tNone || 'K tomuto vozu zatím nemáme kola s posudkem.', true); return; }
        render(es, r[0], r[1].doklady, r[2].produkty, kw);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (q.value || '').trim(), kw = kwIn && kwIn.value ? parseInt(kwIn.value, 10) : null;
      out.hidden = true;
      if (!base) { say(t.tError || 'Vyhledávání teď není dostupné.', true); return; }
      btn.disabled = true;
      var p;
      var vin = v.toUpperCase().replace(/\s+/g, '');
      if (RE_VIN.test(vin) && vinUrl) {
        say(t.tLoading || 'Hledám…');
        p = fetch(vinUrl + '/?vin=' + encodeURIComponent(vin)).then(function (r) { return r.json(); }).then(function (j) {
          if (!j || j.error) { say(t.tVinNotFound || 'Vozidlo s tímto VIN jsme v registru nenašli.', true); return; }
          if (!j.es) { say(t.tVinNoEs || 'Registr k tomuto VIN nevrátil číslo schválení typu. Zadejte ho prosím z technického průkazu (pole K).', true); return; }
          if (kwIn && !kwIn.value && j.kw) kwIn.value = j.kw;
          return searchEs(j.es, kw || j.kw || null);
        });
      } else {
        p = searchEs(v, kw);
      }
      p.catch(function () { say(t.tError || 'Vyhledávání teď není dostupné. Zkuste to prosím později.', true); })
       .finally(function () { btn.disabled = false; });
    });

    // Hledat z adresy: ?tuv=… (jakákoli stránka); v režimu vyhledávání (data-search-mode) i z ?q= a z vyhledávání Typesense.
    var sec = root.closest('.shopify-section') || root, lastQ = null, qt;
    function looksTuv(v) { var s = String(v || '').trim(); return RE_VIN.test(s.toUpperCase().replace(/\s+/g, '')) || RE_ES.test(esBase(s)); }
    function runQ(v) {
      v = String(v || '').trim();
      if (v === lastQ) return; lastQ = v;
      if (t.searchMode === '1') sec.hidden = root.hidden = !looksTuv(v);
      if (!looksTuv(v)) return;
      q.value = v; if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
    var up = new URLSearchParams(location.search);
    if (up.get('tuv')) runQ(up.get('tuv'));
    else if (t.searchMode === '1') runQ(up.get('q') || '');
    if (t.searchMode === '1') document.addEventListener('wu:search', function (e) {
      clearTimeout(qt); qt = setTimeout(function () { runQ(e.detail && e.detail.q); }, 400);
    });
  }
  function boot() { document.querySelectorAll('[data-wu-tuv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
